import React from 'react';
import ReactDOM from 'react-dom';
import OutOfOffice from './OutOfOffice';
import fPopup from './fPopup/index';
const componentElm = typeof global.document !== 'undefined' && global.document.getElementById('OutOfOffice-component');

// fPopup global
export const Popup = global.fPopup ? global.fPopup.default : fPopup;

if (componentElm) {
    const initialState = global.window.initialData.OutOfOffice;

    ReactDOM.render(
        <OutOfOffice {...initialState}/>,
        componentElm
    );
}

export default OutOfOffice;



// WEBPACK FOOTER //
// ./src/index.js